import { render } from "./RegisterpageCom.vue?vue&type=template&id=021f9dfa&scoped=true"
import script from "./RegisterpageCom.vue?vue&type=script&lang=js"
export * from "./RegisterpageCom.vue?vue&type=script&lang=js"

import "./RegisterpageCom.vue?vue&type=style&index=0&id=021f9dfa&scoped=true&lang=css"
import "./RegisterpageCom.vue?vue&type=style&index=1&id=021f9dfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021f9dfa"]])

export default __exports__